import { ComponentConfig, Slot } from '@measured/puck';

type FlexBlockProps = {
  alignItems: 'items-start' | 'items-center' | 'items-end';
  justifyContent: 'justify-start' | 'justify-center' | 'justify-end' | 'justify-between';
  direction: 'flex-row' | 'flex-col';
  gap: 'gap-0' | 'gap-2' | 'gap-4' | 'gap-8';
  wrap: 'flex-wrap' | 'flex-nowrap';
  content: Slot;
};

const FlexBlock: ComponentConfig<FlexBlockProps> = {
  label: 'Flex',
  fields: {
    alignItems: {
      label: 'Align Items',
      type: 'select',
      options: [
        { label: 'Start', value: 'items-start' },
        { label: 'Center', value: 'items-center' },
        { label: 'End', value: 'items-end' },
      ],
    },
    content: {
      type: 'slot',
    },
    direction: {
      label: 'Direction',
      type: 'radio',
      options: [
        { label: 'Row', value: 'flex-row' },
        { label: 'Column', value: 'flex-col' },
      ],
    },
    gap: {
      label: 'Gap',
      type: 'select',
      options: [
        { label: '0', value: 'gap-0' },
        { label: '2', value: 'gap-2' },
        { label: '4', value: 'gap-4' },
        { label: '8', value: 'gap-8' },
      ],
    },
    justifyContent: {
      label: 'Justify Content',
      type: 'select',
      options: [
        { label: 'Start', value: 'justify-start' },
        { label: 'Center', value: 'justify-center' },
        { label: 'End', value: 'justify-end' },
        { label: 'Between', value: 'justify-between' },
      ],
    },
    wrap: {
      label: 'Wrap',
      type: 'radio',
      options: [
        { label: 'true', value: 'flex-wrap' },
        { label: 'false', value: 'flex-nowrap' },
      ],
    },
  },
  defaultProps: {
    alignItems: 'items-start',
    content: [],
    direction: 'flex-row',
    gap: 'gap-0',
    justifyContent: 'justify-start',
    wrap: 'flex-wrap',
  },
  render: ({ alignItems, justifyContent, direction, gap, wrap, content: Content }) => {
    return <Content className={`flex ${gap} ${direction} ${wrap} ${justifyContent} ${alignItems}`} />;
  },
};

export { FlexBlock };
